import React, { Component } from 'react';
import { Tabs } from 'antd';
import './style.less';
import Withdraw from "./WalletWithdraw/withdraw";
import OrderDetails from "./OrderDetails/index";
import BankCard from "./BankCard/index";
const TabPane = Tabs.TabPane;
const clsPrefix = 'walletManage';

class WalletManage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeKey: "1",
        };
    }

    handleTabChange = (activeKey) => {
        this.setState({
            activeKey
        })
    }

    render() {
        const { activeKey } = this.state;
        return (
            <div className={clsPrefix}>
                <Tabs onChange={this.handleTabChange} defaultActiveKey="1" activeKey={activeKey} tabBarGutter={90}>
                    <TabPane tab="提现管理" key="1"><Withdraw onTabChange={this.handleTabChange} /></TabPane>
                    <TabPane tab="订单明细" key="2"><OrderDetails /></TabPane>
                    <TabPane tab="银行卡" key="3"><BankCard /></TabPane>
                </Tabs>
            </div>
        );
    }
}
export default WalletManage;